import React from 'react'
import { x } from '@xstyled/styled-components'
import StyledLink from '../components/ui/Link'

function handleLetterClick (id) {
  document.getElementById(id).scrollIntoView({
    behavior: 'smooth'
  })
}

//
// Receives an array of objects which must have name and slug properties
// Builds up a dictionary with the first letters of names as keys
//
const AlphabeticList = ({ arrayList, sessionId, visitorId, section }) => {
  const dict = arrayList.reduce((previousTrend, currentTrend, index) => {
    let firstLetter = currentTrend.name[0].toUpperCase()
    firstLetter = isNaN(firstLetter) ? firstLetter : '#'
    if (previousTrend[firstLetter]) {
      previousTrend[firstLetter].push(currentTrend)
    } else {
      previousTrend[firstLetter] = [currentTrend]
    }
    return previousTrend
  }, {})
  const clickSource = 'Alphabetic List'
  return (
    <>
      <x.div display='flex' flexWrap='wrap' maxWidth={{ sm: '1260px', wAdD: '1660px' }} w='100%' mx='auto' mb={10}>
        {Object.keys(dict).map(letter => (
          <x.button key={'#letter-' + letter} onClick={() => handleLetterClick('letter-' + letter)} display='inline-block' p='4px 7px' text='medium' bg={{ _: 'ltGrey', hover: 'divider' }} mt={10} mr={10}>{letter}</x.button>
        ))}
      </x.div>
      {Object.keys(dict).map(letter => (
        <x.div key={'letter-' + letter} >
          <x.div id={'letter-' + letter} borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20} w='100%' mt={30}>
            <x.h4>{letter}</x.h4>
          </x.div>
          <x.div display='flex' gap={15} alignItems='center' flexDirection='row' flexWrap='wrap' alignItems='flex-start' className='letters'>
          {dict[letter].map(trend => (
            <StyledLink key={trend.uuid} to={'/' + trend.slug} color={{ hover: 'red' }} display='block' w={{ sm: 'calc((100% - 15px) / 2)', lg: 'calc((100% - 60px) / 5)' }} sessionId={sessionId} section={section} visitorId={visitorId} source={clickSource}>{trend.name}</StyledLink>
          ))}
          </x.div>
        </x.div>
      ))}
    </>
)}

export default AlphabeticList
